import Container from "@mui/material/Container";
import { Box, Typography, useTheme, Grid, Paper } from "@mui/material";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PeopleIcon from "@mui/icons-material/People";
import MainDashboard from "../Dashboard/MainDashboard";

function DashboardRoutes() {
  const theme = useTheme();
  
  const dashboardCards = [
    {
      title: "Custodians",
      icon: <ManageSearchIcon sx={{ fontSize: 40 }} />,
      to: "/custodians",
      color: "#1976d2",
      description: "Manage custodian accounts and settings"
    },
    {
      title: "Transactions",
      icon: <SummarizeOutlinedIcon sx={{ fontSize: 40 }} />,
      to: "/transactions",
      color: "#388e3c",
      description: "View and manage all transactions"
    },
    {
      title: "Investor Management",
      icon: <PeopleIcon sx={{ fontSize: 40 }} />,
      to: "/user_status",
      color: "#f57c00",
      description: "Manage investor accounts and status"
    },
    {
      title: "Strategy Performance",
      icon: <TrendingUpIcon sx={{ fontSize: 40 }} />,
      to: "/strategy",
      color: "#7b1fa2",
      description: "Monitor strategy performance metrics"
    },
    {
      title: "KYC Management",
      icon: <NewspaperIcon sx={{ fontSize: 40 }} />,
      to: "/createkyc",
      color: "#d32f2f",
      description: "Handle KYC verification processes"
    },
    {
      title: "Activity Logs",
      icon: <StackedLineChartIcon sx={{ fontSize: 40 }} />,
      to: "/activity",
      color: "#0288d1",
      description: "View system activity and audit logs"
    }
  ];

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? "#f8fafc"
            : theme.palette.grey[900],
        flexGrow: 1,
        minHeight: "100vh",
        overflow: "auto",
        padding: { xs: 2, sm: 3, md: 4 },
        marginLeft: { xs: 0, sm: "64px", md: "280px" }, // Account for fixed sidebar
        paddingTop: { xs: "80px", sm: "80px", md: "80px" }, // Account for fixed header
        transition: "margin-left 0.3s ease",
      }}
    >
      <Container maxWidth="xl">
        {/* Header Section */}
        <Box sx={{ mb: 4 }}>
          <Typography 
            variant="h3" 
            component="h1" 
            fontWeight="700"
            sx={{ 
              color: theme.palette.mode === "light" ? "#1a202c" : "#fff",
              mb: 1,
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" }
            }}
          >
            Welcome to Admin Panel
          </Typography>
          <Typography 
            variant="h6" 
            sx={{ 
              color: theme.palette.mode === "light" ? "#4a5568" : "#a0aec0",
              fontWeight: 400
            }}
          >
            Manage your platform efficiently with our comprehensive dashboard
          </Typography>
        </Box>

        {/* Dashboard Cards Grid */}
        <Grid container spacing={3}>
          {dashboardCards.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <MainDashboard
                title={card.title}
                icon={card.icon}
                to={card.to}
                color={card.color}
                description={card.description}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default DashboardRoutes;
